/*
 * Jira Ticket:
 * Created Date: Wed, 1st Apr 2020, 15:02:53 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import gql from 'graphql-tag';

export const getOneTowerQuery = gql`
  query Tower($id: ID!) {
    data: Tower(id: $id) {
      id
      site {
        id
        name
        project {
          id
          name
          organisation {
            id
            name
          }
        }
      }
      createdAt
      type {
        id
        name
      }
      status
      tag
      platformHeight
      notes
      files {
        id
        url
        filename
      }
    }
  }
`;
